import Runes from '@/icons/runes'
import featureFlags from '@/utils/feature-flags'

export default {
	icon:  Runes,
	name: 'Runes',
	onClick: ({ router, onClose }: any) => {
		router.push('/runes')
		onClose()
	},
	featured: false,
	filter: ({ loggedIn: _loggedIn }: any) => {
		return !featureFlags('app::disable_runes')
	}
}
